module.exports = __webpack_public_path__ + "static/media/authRemind.b15a4e8c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/authRemind.mp3
// module id = 795
// module chunks = 33